import React from 'react'
import './Credits.css'

const Credits = () => {
  return (
    <span className='credits'>
      Developed By Subodh Palayekar❤️
    </span>
  )
}

export default Credits
